import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const TestimonialSectionnn = () => {
  const testimonials = [
    {
      id: 1,
      image: "images/testimonial/pic1.jpg",
      name: "Mr. Amit Sharma",
      position: "Customer",
      feedback: "I had an amazing experience with AB Ghule Cabs for my trip to Lonavala. The car was clean, comfortable, and well-maintained. The driver was punctual and knowledgeable, ensuring a smooth ride. I highly recommend their services for anyone looking for reliable and hassle-free travel!",
      rating: 5,
    },
    {
      id: 1,
      image: "",
      name: "Miss. Riya Deshmukh",
      position: "Customer",
      feedback: "AB Ghule Cabs exceeded my expectations! The booking process was seamless, and the ride was extremely comfortable. The driver was well-mannered and ensured a safe journey. I highly recommend their service, especially for solo female travelers.",
      rating: 5,
    },
    {
      id: 2,
      image: "images/testimonial/pic2.jpg",
      name: "Mr. Anil Deshmukh",
      position: "Customer",
      feedback: "AB Ghule Cabs made my airport transfer seamless and stress-free. The driver was on time, the car was spotless, and the entire journey was smooth. I’ll definitely be using their services again for my future trips!",
      rating: 5,
    },
    {
      id: 4,
      image: "",
      name: "Miss. Sneha Patel",
      position: "Customer",
      feedback: "I recently used AB Ghule Cabs for an outstation trip, and I was highly impressed. The driver was courteous and drove very safely. The car was clean and luxurious, making the journey smooth and relaxing. I felt completely secure traveling alone. Will definitely book again!",
      rating: 5,
    },
    {
      id: 3,
      image: "images/testimonial/pic3.jpg",
      name: "Mr. Rohit Kulkarni",
      position: "Customer",
      feedback: "I used AB Ghule Cabs for a business trip, and I couldn’t have asked for better service. The car was luxurious, the ride was comfortable, and the driver was professional. It was a great experience that made my trip more convenient and enjoyable. Highly recommended!",
      rating: 5,
    },
 
    {
      id: 5,
      image: "",
      name: "Miss.Priya Sharma",
      position: "Customer",
      feedback: "I recently booked AB Ghule Cabs for a business trip, and I must say, the service was outstanding. The car was spotless and comfortable, and the driver was extremely professional and courteous. As a woman traveling alone, I felt completely safe and at ease throughout the journey. It was a smooth and hassle-free experience. Highly recommended!",
      rating: 5,
    },
    
  ];

  const renderStars = (count) => {
    return Array.from({ length: count }).map((_, i) => (
      <span key={i}>
        <i className="fa fa-star"></i>
      </span>
    ));
  };

  const sliderSettings  = {
    dots: true,  
    infinite: true, 
    speed: 500, 
    slidesToShow: 3, 
    slidesToScroll: 1, 
    autoplay: true,  
    autoplaySpeed: 3000, 
    responsive: [
      {
        breakpoint: 1024,  
        settings: {
          slidesToShow: 3, 
        },
      },
      {
        breakpoint: 768,  
        settings: {
          slidesToShow: 2, 
        },
      },
      {
        breakpoint: 480,  
        settings: {
          slidesToShow: 1, 
        },
      },
    ],
  };

  return (
   <div className="container pb-5">

<div className="section-full p-t150 site-bg-white twm-testimonial-section-wrap wow fadeInDown">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <div className="section-head left">
              <div className="twm-sm-title left">Testimonial</div>
              <h2 className="twm-large-title site-text-dark">
                What Our Customers Say
              </h2>
            </div>
          </div>
        </div>

        <div className="section-content container">
          <Slider {...sliderSettings}>
            {testimonials.map((testimonial) => (
              <div className="item p-2" key={testimonial.id}>
                <div className="twm-testimonial2">
                  <div className="twm-testimonial-head">
                    <div className="media-pic">
                      <img src={testimonial.image} alt="" />
                    </div>
                    <div className="twm-author-detail">
                      <h3 className="twm-title">{testimonial.name}</h3>
                      <div className="twm-position">{testimonial.position}</div>
                    </div>
                  </div>

                  <div className="twm-testimonial-detail">
                    <p>{testimonial.feedback}</p>
                    <div className="twm-rating-wrap">
                      {renderStars(testimonial.rating)}
                    </div>
                  </div>

                  <div className="twm-quote-icon">
                    <img src="images/quote.png" alt="Quote" />
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>

   </div>
  );
};

export default TestimonialSectionnn;
